/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalUserEmailUpdateRequest
 */
export interface ExternalUserEmailUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ExternalUserEmailUpdateRequest
     */
    email?: string | null;
}

/**
 * Check if a given object implements the ExternalUserEmailUpdateRequest interface.
 */
export function instanceOfExternalUserEmailUpdateRequest(value: object): value is ExternalUserEmailUpdateRequest {
    return true;
}

export function ExternalUserEmailUpdateRequestFromJSON(json: any): ExternalUserEmailUpdateRequest {
    return ExternalUserEmailUpdateRequestFromJSONTyped(json, false);
}

export function ExternalUserEmailUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalUserEmailUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
    };
}

export function ExternalUserEmailUpdateRequestToJSON(json: any): ExternalUserEmailUpdateRequest {
    return ExternalUserEmailUpdateRequestToJSONTyped(json, false);
}

export function ExternalUserEmailUpdateRequestToJSONTyped(value?: ExternalUserEmailUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

